import svcs from 'services';
import { RECENT_SEARCH_VALUE_STORAGE_KEY } from 'util/LocalStorageWrapper';
import { create } from 'zustand';

export enum SrchType {
  ALL = 'all',
  DLCENTER = 'dlcenter',
  KNOWLEDGE = 'knowledge',
  QNA = 'qna',
  NEWS_EVENT = 'news-event',
  SAMPLE = 'sample',
}

export type ZstdSrch = {
  setRecents: (v: string[]) => void;
  recents: string[];
  input: string; // 검색버튼 클릭시 변경됨.
  setInput: (v: string) => void;
  inputTmp: string; // 입력중인 검색어
  setInputTmp: (v: string) => void;
  showAiSrch: boolean;
  setShowAiSrch: (v: boolean) => void;
  showMobileSrch: boolean;
  setShowMobileSrch: (v: boolean) => void;
  srchType: SrchType;
  setSrchType: (v: SrchType) => void;
  isAiMode: boolean;
  setIsAiMode: (v: boolean) => void;
  suppressAutoSearch: boolean;
  setSuppressAutoSearch: (v: boolean) => void;
};
export const useZstdSrch = create<ZstdSrch>((set) => ({
  setRecents: (v: string[]) => set({ recents: v }),
  recents: svcs.localStorage?.getItem(RECENT_SEARCH_VALUE_STORAGE_KEY)?.split(','),
  input: '',
  setInput: (v: string) => set({ input: v }),
  inputTmp: '',
  setInputTmp: (v: string) => set({ inputTmp: v }),
  showAiSrch: true,
  setShowAiSrch: (v: boolean) => set({ showAiSrch: v }),
  showMobileSrch: false,
  setShowMobileSrch: (v: boolean) => set({ showMobileSrch: v }),
  srchType: SrchType.ALL,
  setSrchType: (v: SrchType) => set({ srchType: v }),
  isAiMode: localStorage.getItem('isAiMode') === 'true' || false,
  setIsAiMode: (v: boolean) => {
    localStorage.setItem('isAiMode', String(v));
    set({ isAiMode: v });
  },
  suppressAutoSearch: false,
  setSuppressAutoSearch: (v) => set({ suppressAutoSearch: v }),
}));
